import React from "react";
import { Chart } from "react-google-charts";
import GroupModal from "./CCustomQueryBuilder/Modal";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Result from "./CCustomQueryBuilder/Result";
class CustomerFilter extends React.Component {
	constructor(props) {
	    super(props);
	}

	render() {
		let showTable = "";
		let chartView = "";
		let summaryData = "";
		let showSpinnerChart = "";
		let displaySpinner = "";
		return (
			<div>
          <GridContainer style={{marginBottom: "0px"}}>
            <GridItem xs={8} sm={8} md={8} xl={8}>
              <Card
                style={{
                  textAlign: "left",
                  marginBottom: "0px"
                }}
              >
                <div className="filtercentercontent summarycontent">
                  <div
                    className="filteraudiencetitle summarytitle"
                    style={{ minHeight: "40px" }}
                  >
                    <h2 className="capitalize">Filter Criteria</h2>
                    <a href="javascript:void(0)" style={{ float: "right" }}>
                      <GroupModal
                        titleName="Add Filter"
                        buttonLabel="Add Filter"
                        selectedIndex="no_index"
                        selectedRule=""
                        mode="Create"
                        type="group"
                        buttonType="add group"
                        class="withoutbgbtn"
                        style={{ marginRight: "0px" }}
                      />
                    </a>
                  </div>
                  <CardBody
                    style={{
                      textAlign: "left",
                      // overflowY: "auto",
                      minHeight: "370px",
                      marginBottom: "0px"
                    }}
                  >
                    <div className="filtercentercontent">
                      <div className="">
                        {/* <div class="btngroup">
                        <a href="javascript:void(0)" class="btn">
                          <i class="plussign" />
                          add group
                        </a>
                      </div> */}
                        <Result onButton="" />
                      </div>
                    </div>
                 </CardBody>
                 </div>
               </Card>
             </GridItem>
             <GridItem xs={4} sm={4} md={4} xl={4}>
               <Card
                style={{
                  marginBottom: "0px"
                }}
                >
                 <div className="filtercentercontent summarycontent">
                   <div className="filteraudiencetitle summarytitle" style={{minHeight: '40px'}}>
                      <h2 className="capitalize">Summary</h2>
                    </div>
                     <CardBody
                       style={{
                         height: "370px",
                         textAlign: "center",
                         marginBottom: "0px"
                       }}
                     >
                     {displaySpinner === "show" ? showSpinnerChart : displaySpinner === "hide" ? chartView : ""}
                     {displaySpinner === "hide" ? summaryData : "" }
                   </CardBody>
                </div>
              </Card>
            </GridItem>
          </GridContainer>
          <GridContainer>
            {/*<GridItem xs={4} sm={4} md={4} xl={4}>
              <Card>
                <div className="filtercentercontent summarycontent">
                  <div className="filteraudiencetitle summarytitle">
                    <h2 className="capitalize">Control/Hold Out</h2>
                  </div>
                  <CardBody style={{width: "100%", display: 'block', justifyContent: "center"}}>
                    <div style={{paddingTop: "20px"}}>
                    <Slider
                        classes={{ container: classes.slider }}
                        value={this.props.sliderValue['sliderValue']}
                        aria-labelledby="label"
                        step={1}
                        onChange={this.handleSliderChange}
                      />
                      <br/>
                      <h2> {this.props.sliderValue['sliderValue']} % or <strong>{this.numberWithCommas(this.props.sliderValue['excludedCount'])}</strong></h2>
                      <br/>
                      <p>audience members will be excluded</p>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </GridItem>*/}
            <GridItem xs={12} sm={12} md={12} xl={12}>
              <Card>
                <div className="filtercentercontent summarycontent">
                  <div
                    className="filteraudiencetitle summarytitle"
                    style={{ minHeight: "40px" }}
                  >
                    <h2 className="capitalize">Preview</h2>
                  </div>
                  <CardBody
                    style={{
                      textAlign: "left",
                      overflow: "auto",
                      height: "350px"
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {showTable}
                    </div>
                  </CardBody>
                </div>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
		)
	}
}

export default (CustomerFilter);


// WEBPACK FOOTER //
// ./src/views/Audiences/CustomerFilter.jsx